// Side Effects
import App from './components/App.vue'
import Vue from 'vue'
import { store } from './store'
import { configMock } from './config'

export const runApp = (): Vue =>
  new Vue({
    render: createElement => createElement(App),
    store
  }).$mount(`#${configMock.clickFlowID}`)
runApp()
